module.exports = __webpack_public_path__ + "media/images/tables/square-9eed0e7cf08cd21fffd23c8f0eac1b1a.png";